import { A as AccessObject, a as AccessDevice } from '../AccessDevice-68531278.js';
import 'nanoid';
import '@newspaces/zero-base/Model';
import './Organisation.js';
import 'nanoid/generate';
import '@newspaces/zero-base/Runtime';
import '@newspaces/zero-base/models/Organisation';
import '@newspaces/zero-base/utils';
import '../AccessSite-5abc043f.js';
import '../AccessCountries-3e45c6a9.js';
import '@newspaces/zero-base/DateTime';
import '../AccessGroup-4a811995.js';
import './AccessTimeSchedule.js';
import '../i18n.js';
import '@newspaces/zero-base/i18n';
import '../canRemoveDocuments-3b897618.js';
import '../parseChangeSet-03074a6b.js';
import '@blueid/access-proto';
import './AccessConfiguration.js';
import './AccessVendor.js';

AccessObject.Fields.devices.type[0] = AccessDevice;

export { AccessObject as default };
//# sourceMappingURL=AccessObject.js.map
